<template>
  <article class="ws-fin-conta-row" :class="`ws-fin-conta-row--${status}`">
    <div class="ws-fin-conta-row__bar" />
    <div
      class="ws-fin-conta-row__flow-icon ws-fin-conta-row__flow-icon--saida"
      :title="t('workspaceFinanceiroServicos.movimentoGasto')"
      aria-hidden="true"
    >
      <svg fill="none" stroke="currentColor" viewBox="0 0 24 24" stroke-width="2.25">
        <path stroke-linecap="round" stroke-linejoin="round" d="M17 13l-5 5m0 0l-5-5m5 5V6" />
      </svg>
    </div>
    <div class="ws-fin-conta-row__main">
      <div class="ws-fin-conta-row__head">
        <span class="ws-fin-conta-row__nome">{{ conta.nome }}</span>
        <span class="ws-fin-conta-row__badge" :class="`ws-fin-conta-row__badge--${status}`">{{ statusLabel }}</span>
      </div>
      <p v-if="conta.descricao" class="ws-fin-conta-row__desc">{{ conta.descricao }}</p>
      <p class="ws-fin-conta-row__meta">
        <span class="ws-fin-conta-row__date">
          <svg fill="none" stroke="currentColor" viewBox="0 0 24 24" stroke-width="2" aria-hidden="true"><path stroke-linecap="round" stroke-linejoin="round" d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z"/></svg>
          {{ t('workspaceFinanceiroServicos.row.vencimento', { date: formatDate(conta.dataVencimento) }) }}
        </span>
        <span v-if="conta.isPago && conta.dataPagamento" class="ws-fin-conta-row__paid">
          {{ t('workspaceFinanceiroServicos.row.pagoEm', { date: formatDate(conta.dataPagamento) }) }}
        </span>
      </p>
    </div>
    <div class="ws-fin-conta-row__valor" aria-hidden="true">
      <MoneyAmount :value="conta.valor" size="md" />
    </div>
    <div class="ws-fin-conta-row__actions">
      <button
        v-if="!conta.isPago"
        type="button"
        class="ws-fin-conta-row__btn ws-fin-conta-row__btn--pay"
        :title="t('workspaceFinanceiroServicos.actions.marcarPago')"
        @click="$emit('marcar-pago', conta.id)"
      >
        <svg fill="none" stroke="currentColor" viewBox="0 0 24 24" stroke-width="2" aria-hidden="true"><path stroke-linecap="round" stroke-linejoin="round" d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z"/></svg>
        <span class="ws-fin-conta-row__btn-label">{{ t('workspaceFinanceiroServicos.actions.marcarPago') }}</span>
      </button>
      <button
        v-else
        type="button"
        class="ws-fin-conta-row__btn ws-fin-conta-row__btn--undo"
        :title="t('workspaceFinanceiroServicos.actions.desfazer')"
        @click="$emit('desmarcar-pago', conta.id)"
      >
        <svg fill="none" stroke="currentColor" viewBox="0 0 24 24" stroke-width="2" aria-hidden="true"><path stroke-linecap="round" stroke-linejoin="round" d="M3 10h10a8 8 0 018 8v2M3 10l4-4m-4 4l4 4"/></svg>
      </button>
      <button
        v-if="!conta.isPago"
        type="button"
        class="ws-fin-conta-row__btn ws-fin-conta-row__btn--del"
        :title="t('common.delete')"
        @click="$emit('delete', conta.id)"
      >
        <svg fill="none" stroke="currentColor" viewBox="0 0 24 24" stroke-width="2" aria-hidden="true"><path stroke-linecap="round" stroke-linejoin="round" d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16"/></svg>
      </button>
    </div>
  </article>
</template>

<script setup>
import { computed } from 'vue'
import { useI18n } from 'vue-i18n'
import MoneyAmount from '@/components/MoneyAmount.vue'
import { contaPagarStatus, formatDateBR } from '@/utils/financeiroServicosMetrics'

const props = defineProps({
  conta: { type: Object, required: true }
})

defineEmits(['marcar-pago', 'desmarcar-pago', 'delete'])

const { t } = useI18n()

const status = computed(() => {
  if (props.conta.isPago) return 'pago'
  return contaPagarStatus(props.conta)
})

const statusLabel = computed(() => {
  const map = {
    atrasado: t('workspaceFinanceiroServicos.status.atrasado'),
    pendente: t('workspaceFinanceiroServicos.status.pendente'),
    pago: t('workspaceFinanceiroServicos.status.pago')
  }
  return map[status.value] || map.pendente
})

function formatDate (value) {
  return formatDateBR(value)
}
</script>
